import { lazy } from 'react';

export const ExamQuestionList = lazy(() => import('./ExamQuestionList'));
export const AddExamQuestion = lazy(() => import('./AddExamQuestion'));
